import React from "react";
import { Modal, Flex, Tabs, Divider } from "antd";
import CustomAvatar from "../../../Components/CustomAvatar";

const UserProfileModal = ({ userSelfData, onModalUpdate }) => {
  const handleCloseModal = () => onModalUpdate({ activeModal: "" });

  const tabItems = [
    {
      label: "Profile Settings",
      icon: <i className="fa-solid fa-gear"></i>,
      key: "1",
    },
  ];

  const profileFields = [
    { title: "Full Name", value: userSelfData?.fullName },
    { title: "Username", value: userSelfData?.username },
  ];

  return (
    <Modal
      title="Profile"
      open={true}
      onCancel={handleCloseModal}
      footer={null}
      className="ec-modal mobile-profile-setting"
      width={800}
      style={{ top: 30, maxHeight: "80vh" }}
    >
      <Flex className="modal-sidebar">
        <Tabs
          tabPosition="left"
          activeKey="1"
          style={{ width: "100%" }}
          items={tabItems}
        />
      </Flex>
      <Flex className="modal-main">
        <div className="settings-content minimize-settings">
          <div>
            <Flex gap="small" vertical className="user-settings">
              <h4 className="tab-header">Profile Settings</h4>
              <Divider />

              {profileFields.map((field, index) => (
                <React.Fragment key={field.title}>
                  <Flex vertical className="settings">
                    <Flex justify="space-between" gap="small">
                      <h4 className="settings__title">{field.title}</h4>
                    </Flex>
                    <Flex className="settings__description">{field.value}</Flex>
                  </Flex>
                  <Divider />
                </React.Fragment>
              ))}

              <Flex vertical className="settings">
                <Flex justify="space-between" gap="small">
                  <h4 className="settings__title">Profile Picture</h4>
                </Flex>
                <Flex className="settings__description">
                  <CustomAvatar
                    size={60}
                    img={userSelfData?.avatarUrl || userSelfData?.thumbnail_avatarUrl}
                    userName={userSelfData?.username}
                  />
                </Flex>
              </Flex>
            </Flex>
          </div>
        </div>
      </Flex>
    </Modal>
  );
};

export default UserProfileModal;
